export default "/images/vendor/flag-icon-css/flags/4x3/mt.svg?a39094a015bbe6ba386122e4d23918eb";